import i18next from 'i18next';
import { getLocales } from './getLocales';
var I18Service = (function () {
    function I18Service(locale) {
        Object.defineProperty(this, "i18next", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.i18next = i18next.createInstance();
        var locales = getLocales();
        this.i18next.init({
            interpolation: {
                escapeValue: false,
            },
            lng: locale,
            resources: locales,
            fallbackLng: 'en',
            supportedLngs: ['en', 'ru', 'es'],
        });
    }
    Object.defineProperty(I18Service.prototype, "update", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (attrs) {
            this.i18next.changeLanguage(attrs.locale);
        }
    });
    return I18Service;
}());
export { I18Service };
//# sourceMappingURL=i18nservice.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/services/i18nservice.js
// module id = 1378
// module chunks = 118